import React from 'react';
import DataTable from '../reporting_utils/DataTable';

const $ = window.$;

/**
 * @param {{
 *   tableData: Array;
 *   isAutomotiveIndustry: boolean;
 *   isTextingEnabled: boolean;
 *   industryType: string;
 * }} props
 */
export default function ConversionSummaryTable({
  tableData,
  isAutomotiveIndustry,
  isTextingEnabled,
  industryType,
}) {
  const columnDefs = React.useMemo(() => {
    /** @type {string[]} */
    let callTypes = [];
    switch (industryType) {
      case 'Automotive':
        callTypes = ['Sales', 'Service', 'Parts'];
        break;
      case 'Pest':
        callTypes = ['One-Time Service', 'Recurring Service'];
        break;
      case 'Home Improvement':
        // callTypes = ['Sales', 'Service', 'Customer Service', 'Outbound-Not Connected']; -- Removed for transition
        callTypes = ['Sales', 'Service'];
        break;
      case 'Healthcare':
        callTypes = ['Prospect', 'Current Patient'];
        break;
      case 'Other':
        callTypes = ['Sales', 'Prospect'];
        break;
      default:
        callTypes = [];
    }

    /** @type {import('../reporting_utils/DataTable').Column[]} */
    const columns = [];

    columns.push({ data: 'adsource', title: 'Source' });

    if (industryType !== 'Call Center') {
      columns.push({ data: 'ref_medium', title: 'Referral' });
      columns.push({
        data: 'chats',
        render: $.fn.dataTable.render.number(','),
        aggregation: 'sum',
        title: 'Chats',
      });
      columns.push({
        data: 'leads',
        render: $.fn.dataTable.render.number(','),
        aggregation: 'sum',
        title: 'WebForms',
      });

      if (isTextingEnabled) {
        columns.push({
          data: 'texts',
          render: $.fn.dataTable.render.number(','),
          aggregation: 'sum',
          title: 'Texts',
        });
      }
    }

    columns.push({
      data: 'calls',
      render: $.fn.dataTable.render.number(','),
      aggregation: 'sum',
      title: 'Calls',
    });

    callTypes.forEach((callType) => {
      columns.push({
        data: callType.replace(/[^a-z]/gi, '_').toLowerCase(),
        render: $.fn.dataTable.render.number(','),
        aggregation: 'sum',
        title: callType,
      });
    });

    columns.push({
      data: 'appts',
      render: $.fn.dataTable.render.number(','),
      aggregation: 'sum',
      title: isAutomotiveIndustry ? 'Appts Made' : 'Booked Calls',
    });
    columns.push({
      data: 'noappts',
      render: $.fn.dataTable.render.number(','),
      aggregation: 'sum',
      title: isAutomotiveIndustry ? 'Alerts' : 'Missed Opps',
    });

    return columns;
  }, [industryType, isAutomotiveIndustry, isTextingEnabled]);

  const order = React.useMemo(() => {
    const callsColumnIndex = columnDefs.findIndex((column) => column.data === 'calls');
    return [[callsColumnIndex, 'desc']];
  }, [columnDefs]);

  return (
    <div>
      <div className='text-center'>
        <h3>Conversion Summary</h3>
      </div>
      <DataTable
        title='Conversion Summary'
        data={tableData}
        columnDefs={columnDefs}
        showTotalFooter={true}
        order={order}
        selectColumns={false}
        exportData={false}
      />
    </div>
  );
}
